import { ReactNode } from 'react';
import { Button, Col, Modal, ModalProps, Row } from 'react-bootstrap';

type Props = {
  type: string;
  name: string;
  onConfirm: () => void;
  /** Optional warning shown above the question; also tweaks the confirm button to a danger style. */
  warning?: ReactNode;
  confirmLabel?: string;
} & ModalProps;

const DeleteVanityModal = ({ type, name, warning, confirmLabel, show, onHide, onConfirm }: Props) => {
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Body>
        {warning && (
          <Row className="mt-3">
            <Col className="text-center text-danger font-weight-bold">{warning}</Col>
          </Row>
        )}
        <Row className="mt-4">
          <Col className="text-center">
            Delete {name} {type}?
          </Col>
        </Row>
        <Row style={{ display: 'flex', justifyContent: 'space-around' }} className="mt-5 pl-1">
          <Button variant={warning ? 'danger' : 'success'} className="w-30" onClick={onConfirm}>
            {confirmLabel ?? 'Confirm'}
          </Button>
          <Button className="w-30" onClick={onHide}>
            Cancel
          </Button>
        </Row>
      </Modal.Body>
    </Modal>
  );
};

export default DeleteVanityModal;
